import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { TonProvider } from "./providers/TonProvider";
import { TelegramProvider } from "./providers/TelegramProvider";
import "./styles/main.scss";
import "./styles/responsive.scss";


ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <TelegramProvider>
            <TonProvider>
                <App />
            </TonProvider>
        </TelegramProvider>
    </React.StrictMode>
);